export enum ContractVariant {
  VALUE = 'VALUE',
  QUANTITY = 'QUANTITY',
}

export interface ContractDetailsData {
  contractVariant: ContractVariant;
  plannedContractValue?: number | undefined;
  items?: ContractDetailsLineItem[] | undefined;
}

export interface ContractDetailsLineItem {
  position: number;
  title: string;
  description: string;
  unit: string;
  currency: string;
  plannedQuantity: number;
  plannedVolume: string;
  pricePerUnit: number;
}
